import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Hexagon = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="79" viewBox="0 0 79 68" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M58.5687 0.444153H19.5841L0.0922546 34.2054L19.5841 67.9677H58.5687L78.0615 34.2054L58.5687 0.444153Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
